/**
 * created by li si yi
 * 绑定网站用户-选择用户弹窗
 */
import React, {Component} from 'react';
import {message, Modal, Steps, Input, Pagination, Button} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";

const {Search} = Input;
export default class SelectUserModal extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            contentVisible: false,//显示
            params: {
                page: 1,
                size: 10,
                mediaId: '',
                query: "",
            },
            tableParams: {
                page: 1,
                size: 10,
                mediaId: '',
            },
            count: 0,
            selectData: {},//当前选中的数据
            currentData: {},//当前用户
            currentClick: {},//前一个页面传过来的id
            dataSource: [],// 接口数据
            tableDataSource: [],// 接口数据
            currentUser: '',
            searchVal: '',
            flag:false,// 判断是否是从绑定用户进去
            columns: [
                {
                    title: '姓名',
                    dataIndex: 'wbname',
                    key: 'wbname',
                    ellipsis: true,
                    width: 200,
                },
                {
                    title: '账号',
                    dataIndex: 'wbaccount',
                    key: 'wbaccount',
                    width: 200,
                    ellipsis: true,
                    render: (text) => {
                        return text || 0
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    ellipsis: true,
                    width: 100,
                    render: (text, record, index) => {
                        return (
                            <div style={{color: this.themeBgColor, cursor: 'pointer'}} onClick={() => {
                                this.selectStatus(record, index);
                                // this.state.currentData.vsbUserAccount;
                            }}>{record.isSelected ? "取消选中" : "选中"}</div>
                        )
                    }
                },
            ],
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/*弹窗*/}
                {this.renderModal()}
            </div>
        )
    }

    renderModal() {
        const {contentVisible} = this.state;
        return (
            <>
                <Modal title={"选择用户"} width={800}
                       visible={contentVisible}
                       onCancel={this.handleCancelContent}
                       bodyStyle={{maxHeight: 600}}
                       zIndex={9999}
                       footer={<div style={{}}>
                           <div style={{
                               float: "left",
                               marginTop: 6
                           }}>当前用户：{this.state.selectData && this.state.selectData.wbname ? this.state.selectData.wbname : "未选中"}</div>
                           <div style={{margin: "0px 112px"}}>
                               <Button onClick={this.handleCancelContent}>取消</Button>
                               <Button type={"primary"} onClick={this.handleOk}>确认</Button>
                           </div>
                       </div>}
                >
                    <Search allowClear style={{width: 240, marginBottom: 24}} value={this.state.searchVal}
                            placeholder={'请输入姓名或账号'} onChange={(e) => {
                        this.setState({
                            searchVal: e.target.value
                        });
                    }} onSearch={(e, value) => {
                        this.searchUser(e, value)
                    }}/>
                    {/*选择用户列表*/}
                    {this.renderTable()}
                </Modal>
            </>
        )
    }

    // 搜索
    searchUser = (e, value) => {
        let paramsTemp = {...this.state.params};
        // let tableDataSource = [];
        // this.state.dataSource && this.state.dataSource.find(item => {
        //     if (item.wbname && item.wbname.indexOf(e) > -1 || (item.wbaccount && item.wbaccount.indexOf(e) > -1)) {
        //         tableDataSource.push(item);
        //     }
        // });
        // if (e) {
        //     // page size 1,10
        //     this.state.tableParams.page = 1;
        //     query = e
        //     // this.tableData(this.state.tableParams.page, this.state.tableParams.size)
        // }
        // console.log(this.state.selectData, this.state.currentUser);
        this.state.tableParams.page = 1;
        paramsTemp.query = e;
        paramsTemp.page = 1;
        this.setState({ params: paramsTemp },()=>{
            this.getItemDataSource()
        })
        // this.state.count = tableDataSource.length;
        // this.setState({
        //     tableDataSource,
        // })
    };
    // 点击确定
    handleOk = () => {
        let {selectData} = this.state;
        // console.log(selectData);
        this.bindVsbUser();
        this.setState({
            contentVisible: false
        });
    };
    //列表
    renderTable = () => {
        const {dataSource, columns, tableDataSource} = this.state;
        return (
            <div className={'recordStyle'} id={"checkUserBorder"}>
                <Scrollbars autoHide autoHeight autoHeightMax={440}>
                    <BaseTable rowKey={(record,index)=>`${record?.wbsysuserid}${index}`} dataSource={dataSource} columns={columns} />
                </Scrollbars>
                {dataSource && dataSource.length > 0 ? this.renderFooter() : ""}
                <style>{`
                #checkUserBorder .ant-table-placeholder{border-bottom: 0;}
                `}</style>
            </div>
        )
    };
    // 数据
    // tableData = (page, size) => {
    //     let dataSource = [];
    //     dataSource = JSON.parse(JSON.stringify(this.state.dataSource));
    //     let data = dataSource.splice((page - 1) * size, (page * size));
    //     this.state.tableDataSource = data;
    //     console.log("this.state.tableDataSource         ", this.state.tableDataSource);
    //     this.setState({})
    // };

    // 是否选中状态
    selectStatus(record, index) {
        let dataSourceTemp = [...this.state.dataSource];
        let selectDataTemp = {}
        let status = JSON.parse(JSON.stringify(record.isSelected ? true : false));
        if (!status) {
            selectDataTemp = record
        }
        dataSourceTemp.forEach(item => {
            item.isSelected = false
        });
        dataSourceTemp[index].isSelected = !status;
        this.setState({ dataSource: dataSourceTemp, selectData: selectDataTemp })
    }

    // 获取数据
    getItemDataSource = () => {
        message.destroy();
        this.request({
            url: "/cm-sites-pms/website/getUserList",
            body: this.state.params,
            callBack: (res) => {
                let dataSource = [];
                let tableDataSource = [];
                let count = 0;
                if (res) {
                    dataSource = res.data;
                    count = res.total;
                    // this.state.dataSource = dataSource;
                    // this.state.count = count;
                    dataSource.map(item => {
                        if (this.state.selectData && (this.state.selectData.wbaccount === item.wbaccount)) {
                            item.isSelected = true
                        } else {
                            item.isSelected = false
                        }
                    });
                    // 前端做搜索，先保存数据
                    // tableDataSource = this.state.dataSource;
                }
                this.setState({contentVisible: true, dataSource, count})
            },
            errorCallBack: (e) => {
                console.log(e)
            },
            serverVerify: {
                serverErrorCallBack: (e, allData) => {
                    if (!allData.data) {
                        if(this.state.flag){
                            message.error('媒体未认证无法获取网站用户信息，请先进行媒体账号认证！');
                        }else{
                            message.error('媒体未认证！');
                        }

                        this.setState({contentVisible: false, tableDataSource: []})
                    }
                },
                isShowErrorMsg: false
            }
        });
    };
    // 绑定网站
    bindVsbUser = () => {
        let {currentData, currentClick, selectData} = this.state;

        let params, url, contentType;
        if (selectData && selectData.wbaccount && selectData.wbname) {
            params = {
                "owner": currentData.owner ||currentData?.mediaProperty?.owner,
                "userId": currentClick.userId || currentClick.id.value ? currentClick.userId || currentClick.id.value : '',
                "userName": currentClick.userName || currentClick.name.value ? currentClick.userName || currentClick.name.value : '',
                "vsbUserAccount": selectData.wbaccount,
                "vsbUserName": selectData.wbname
            };
            url = '/cm-sites-pms/website/bindVsbUser';
            contentType = 'json';
        } else {
            params = {
                "owner": currentData.owner ||currentData?.mediaProperty?.owner,
                "userId": currentClick.userId || currentClick.id.value ? currentClick.userId || currentClick.id.value : '',
            };
            url = '/cm-sites-pms/website/unbindVsbUser';
            contentType = 'form-data';
        }
        this.request({
            url: url,
            body: params,
            method: 'post',
            contentType: contentType,
            callBack: (res) => {

                if (res) {
                    if (selectData && selectData.wbaccount && selectData.wbname) {
                        this.callback && this.callback()
                    } else {
                        message.success('解绑成功');
                        this.callback && this.callback()
                    }
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    show = (flag, record, currentClick, callback) => {
        this.setState({flag: flag}, () => {
               this.showModal(flag,record, currentClick, callback)
        })
    };
    // 显示
    showModal = (flag,record, currentClick, callback) => {

        this.callback = callback;
        this.state.params.mediaId = record.mediaId||record.id;
        this.setState({
            // contentVisible: true,
            currentData: record,
            currentClick: currentClick?currentClick:{},
            currentUser: record.vsbUserName,
            selectData: {
                wbaccount:flag?currentClick.vsbUserAccount: record.vsbUserAccount,
                wbname:flag?currentClick.vsbUserName: record.vsbUserName
            },
            searchVal: '',
            tableParams: {
                page: 1,
                size: 10,
                mediaId: record.mediaId
            },
            params: {
                page: 1,
                size: 10,
                mediaId: record.mediaId || record.id
            }
        }, () => {

            this.getItemDataSource()
        });
        // this.state.params.mediaId = record.mediaId;
    };
    // 取消
    handleCancelContent = () => {
        this.setState({contentVisible: false, searchVal: ""});
    };
    // 分页
    renderFooter = () => {
        let {params, count, tableParams} = this.state;
        let {page, size} = params;
        return (
            <div className={'pagination'}
                 style={{borderTop: '1px solid #e6e6e6', padding: '24px 0px', position: 'relative'}}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={page}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    };
    // 分页改变
    pageChange = (page, size) => {
        let params = { ...this.state.params };
        this.state.tableParams.page = page;
        this.state.tableParams.size = size;
        params.page = page;
        params.size = size;
        this.setState({ params }, () => {
            // this.tableData(this.state.tableParams.page, this.state.tableParams.size)
            this.getItemDataSource();
        })
    };
}